// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 3.5H3.5M2.5 8H3.5M2.5 12.5H3.5',
  'M5.75 3.5H13.5M5.75 8H13.5M5.75 12.5H13.5',
];
